function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaisedHand = function SvgRaisedHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 40.14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 36.6a12.19 12.19 0 0 0 8.67 3.54A12.39 12.39 0 0 0 34 27.79V6.5a2.17 2.17 0 1 0-4.33 0v12H27.5V3.61a2.17 2.17 0 0 0-4.33 0V17H21V2.17a2.17 2.17 0 1 0-4.33 0v15.59h-2.16V4.33a2.17 2.17 0 0 0-4.33 0V27.5L3.68 21a2.08 2.08 0 0 0-3 0 2.08 2.08 0 0 0 0 3Z",
    style: {
      fill: "#fff"
    },
    "data-name": "Layer 1"
  })));
};
export default SvgRaisedHand;